import reducer, { State } from './reducer';

export const TokenReducer = { dodoToken: reducer };
export type TokenState = { dodoToken: State };
